<template>
  <div>
    <div class="utils__title mb-3">
      <strong class="text-uppercase font-size-16">{{
        $t("admin.user.title")
      }}</strong>
    </div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <a-table
              :columns="columns"
              :rowKey="(record) => record.uid"
              :dataSource="data"
              :loading="loading"
              :pagination="false"
            >
              <div
                slot="filterDropdown"
                slot-scope="{
                  setSelectedKeys,
                  selectedKeys,
                  confirm,
                  clearFilters,
                  column,
                }"
                style="padding: 8px"
              >
                <a-input
                  v-ant-ref="(c) => (searchInput = c)"
                  :placeholder="`Search ${column.dataIndex}`"
                  :value="selectedKeys[0]"
                  @change="
                    (e) =>
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                  "
                  @pressEnter="() => handleSearch(selectedKeys, confirm)"
                  style="width: 188px; margin-bottom: 8px; display: block"
                />
                <a-button
                  type="primary"
                  @click="() => handleSearch(selectedKeys, confirm)"
                  icon="search"
                  size="small"
                  style="width: 90px; margin-right: 8px"
                  >Search</a-button
                >
                <a-button
                  @click="() => handleReset(clearFilters)"
                  size="small"
                  style="width: 90px"
                  >Reset</a-button
                >
              </div>
              <a-icon
                slot="filterIcon"
                slot-scope="filtered"
                type="search"
                :style="{ color: filtered ? '#108ee9' : undefined }"
              />
              <template slot="stt" slot-scope="id, record, index">
                {{ (currentPage - 1) * perPage + index + 1 }}
              </template>
              <template slot="name" slot-scope="title, record">
                <router-link :to="`/admin/user/${record.uid}`">{{
                  record.name ||
                  record.email ||
                  record.phoneNumber ||
                  record.uid
                }}</router-link>
              </template>
              <template slot="created" slot-scope="created">
                {{ formatDate(created) }}
              </template>
              <template slot="lastSign" slot-scope="lastSign">
                {{ formatDate(lastSign) }}
              </template>
              <template slot="coin" slot-scope="coin">
                {{ coin }}
              </template>
            </a-table>
            <div class="pagination">
              <a-button :disabled="currentPage <= 1" @click="() => prevPage()"
                >prev</a-button
              >
              <a-button :disabled="disabledButtonNext" @click="() => nextPage()"
                >next</a-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/mixins/api";
import helper from "@/mixins/helper";
export default {
  data() {
    const columns = [
      {
        title: "#",
        width: "50px",
        dataIndex: "id",
        scopedSlots: { customRender: "stt" },
      },
      {
        title: "User",
        dataIndex: "user",
        scopedSlots: {
          filterDropdown: "filterDropdown",
          filterIcon: "filterIcon",
          customRender: "name",
        },
      },
      {
        title: "Created_at",
        dataIndex: "created",
        width: "20%",
        scopedSlots: { customRender: "created" },
      },
      {
        title: "Last_Sign",
        dataIndex: "lastSign",
        width: "20%",
        scopedSlots: { customRender: "lastSign" },
      },
      {
        title: "Coin",
        dataIndex: "coin",
        width: "15%",
        scopedSlots: { customRender: "coin" },
      },
    ];
    return {
      currentPage: 1,
      perPage: 10,
      columns,
      data: [],
      loading: false,
    };
  },
  computed: {
    disabledButtonNext() {
      if (this.data.length < 10) {
        return true;
      }
      return false;
    },
  },
  methods: {
    loadData(user = "") {
      this.loading = true;
      this.api(
        "admin/user?user=" +
          encodeURIComponent(user.trim()) +
          "&currentPage=" +
          this.currentPage +
          "&perPage=" +
          this.perPage
      )
        .then((res) => {
          this.defaultData = this.data = res.sort(function (a, b) {
            return (
              new Date(b.created).getTime() - new Date(a.created).getTime()
            );
          });
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    async handleSearch(selectedKeys, confirm) {
      confirm();
      if (!selectedKeys[0]) return;
      this.api(
        "admin/searchUser?queryText=" +
          encodeURIComponent(selectedKeys[0].trim())
      ).then((res) => {
        this.data = res;
      });
      this.searchText = selectedKeys[0];
    },
    handleReset(clearFilters) {
      this.data = this.defaultData;
      clearFilters();
      this.searchText = "";
    },
    formatDate(e) {
      let dd = new Date(e).getDate();
      let mm = new Date(e).getMonth() + 1; //January is 0!
      let yyyy = new Date(e).getFullYear();

      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      return dd + "/" + mm + "/" + yyyy;
    },
    nextPage() {
      this.currentPage += 1;
      this.loading = true;
      this.api(
        "admin/user?currentPage=" +
          this.currentPage +
          "&perPage=" +
          this.perPage
      )
        .then((res) => {
          this.defaultData = this.data = res.sort(function (a, b) {
            return (
              new Date(b.created).getTime() - new Date(a.created).getTime()
            );
          });
        })
        .finally((e) => {
          this.loading = false;
        });
    },
    prevPage() {
      this.currentPage -= 1;
      this.loading = true;
      this.api(
        "admin/user?currentPage=" +
          this.currentPage +
          "&perPage=" +
          this.perPage
      )
        .then((res) => {
          this.defaultData = this.data = res.sort(function (a, b) {
            return (
              new Date(b.created).getTime() - new Date(a.created).getTime()
            );
          });
        })
        .finally((e) => {
          this.loading = false;
        });
    },
  },
  mounted() {
    this.loadData();
  },
  mixins: [api, helper],
};
</script>
<style scoped>
a {
  color: #ff5254;
}
a:hover {
  color: #08f;
}
.pagination {
  float: right;
  margin: 16px 0;
}
</style>
